// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBqVew0p6TxeOxW-2aAiWTuc65FNjWFXGA",
    authDomain: "earthency-1f211.firebaseapp.com",
    databaseURL: "https://earthency-1f211.firebaseio.com",
    projectId: "earthency-1f211",
    storageBucket: "earthency-1f211.appspot.com",
    messagingSenderId: "517477192351",
    appId: "1:517477192351:web:ef0a797aaa36075ddec8aa",
    measurementId: "G-XRSGP5002J"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
